import { Keyword, List, Token, Tuple } from "@siteimprove/alfa-css";
import { Parser } from "@siteimprove/alfa-parser";
import { Shorthand } from "../shorthand.js";
import * as X from "./background-repeat-x.js";
/**
 * background-repeat-x and background-repeat-y are identical.
 * We mimic the needed bits here to avoid confusion in the main parser.
 */
var Y;
(function (Y) {
    Y.parse = X.parse;
})(Y || (Y = {}));
const { map, either, delimited, option, pair } = Parser;
/**
 * @internal
 */
export const parse = either(map(pair(X.parse, option(delimited(option(Token.parseWhitespace), Y.parse))), ([x, y]) => Tuple.of(x, y.getOr(x))), map(Keyword.parse("repeat-x"), () => Tuple.of(Keyword.of("repeat"), Keyword.of("no-repeat"))), map(Keyword.parse("repeat-y"), () => Tuple.of(Keyword.of("no-repeat"), Keyword.of("repeat"))));
const parseList = List.parseCommaSeparated(parse);
/**
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/background-repeat}
 * @internal
 */
export default Shorthand.of(["background-repeat-x", "background-repeat-y"], map(parseList, (repeats) => {
    const xs = [];
    const ys = [];
    for (const repeat of repeats) {
        const [x, y] = repeat.values;
        xs.push(x);
        ys.push(y);
    }
    return [
        ["background-repeat-x", List.of(xs, ", ")],
        ["background-repeat-y", List.of(ys, ", ")],
    ];
}));
//# sourceMappingURL=background-repeat.js.map